import { API } from "@akc/biz-api";
import {
  ConfirmOrderParams,
  ConfirmOrderResponse,
  CreateOrderParams,
  CreateOrderResponse,
  PrePayParams,
} from "./types.d";

/**
 * 确认订单
 * @param params
 * @returns
 */
export const confirmOrder = async (params: ConfirmOrderParams) => {
  return API.post<ConfirmOrderResponse>({
    hostID: "h5shop",
    path: "/api/open/osm/outer/xh5/order/confirm",
    body: params,
  });
};

/**
 * 创建订单
 * @param params
 * @returns
 */
export const createOrder = async (params: CreateOrderParams) => {
  return API.post<CreateOrderResponse>({
    hostID: "h5shop",
    path: "/api/open/osm/outer/xh5/order/create",
    body: params,
  });
};

/**
 * 预支付
 * */
export const prePay = async (params: PrePayParams) => {
  return API.post<string>({
    hostID: "h5shop",
    path: "/api/payment/pay/createPayment",
    body: params,
  });
};
